import baseLogger, { CONTEXTS } from 'widget/logger';
import createTaggedUrl from 'api/createTaggedUrl';
import HttpError from 'widget/Errors/HttpError';
import Logger from 'modules/Logger/Logger';
import { TransportInterface } from 'widget/utils/transport/types';

export type PodcastEpisode = {
  description?: string;
  imageUrl?: string;
  mediaUrl?: string;
  title?: string;
};

/*
 * Fetch podcast episode data given an episode id
 */
export async function fetchPodcastEpisode({
  ampUrl = '',
  episodeId,
  logger = baseLogger,
  transport,
}: {
  ampUrl?: string;
  episodeId: number | null;
  logger?: Logger;
  transport: TransportInterface;
}) {
  if (!episodeId) {
    const errObj = new HttpError(
      400,
      'Failed to fetch podcast episode info, podcast episode id missing',
    );
    logger.error(CONTEXTS.SERVER, errObj.message, {}, errObj);
    throw errObj;
  }

  const [url, requestName] = createTaggedUrl`${{
    ampUrl,
  }}/api/v3/podcast/episodes/${{
    episodeId: String(episodeId),
  }}`;

  const response = await transport.get(url, { params: { requestName } });

  const { data } = response as { data: { episode: PodcastEpisode } };

  return data.episode;
}
